import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core';
import {AuthSession} from "@awsscm/awsscm-auth-manager/auth/type";
import {fetchWithAWSAuth} from "../../helperMethods/FederatedIdentity";
import KatalMetricsPublisher from "@katal/metrics/lib/KatalMetricsPublisher";

export default class GqlClient {
    private katalMetricPublisher: KatalMetricsPublisher;
    private session: AuthSession | null;
    private authToken: string;
    private region: string;

    constructor(
        metricPublisher: KatalMetricsPublisher,
        authSession: AuthSession | null,
        token: string,
        region: string
    ) {
        this.katalMetricPublisher = metricPublisher;
        this.session = authSession;
        this.authToken = token;
        this.region = region;
    }

    private fetch = (input: RequestInfo, init?: RequestInit) => {
        return fetchWithAWSAuth(
            input,
            this.katalMetricPublisher,
            this.session,
            this.authToken,
            this.region,
            init
        );
    };

    private client = () => {
        const uri = '/graphV2';
        return new ApolloClient({
            cache: new InMemoryCache({}),
            link: new HttpLink({
                uri,
                fetch: this.fetch
            }),
            queryDeduplication: false
        });
    };

    getClient = (): ApolloClient<any> => {
        return this.client();
    };
}